import React from 'react';
import MastercardIcon from '../../icons/brands/MastercardIcon';
import VisaIcon from '../../icons/brands/VisaIcon';
import EloIcon from '../../icons/brands/EloIcon';
import AmexIcon from '../../icons/brands/AmexIcon';
import HipercardIcon from '../../icons/brands/HipercardIcon';
// TODO: portar DinersIcon (arquivo muito grande — fazer revisão manual)

const brandMap = {
  MASTERCARD: MastercardIcon,
  VISA: VisaIcon,
  ELO: EloIcon,
  AMEX: AmexIcon,
  HIPERCARD: HipercardIcon,
};

interface BrandIconProps {
  brand?: string;
  size?: string;
}

function BrandIcon({ brand = '', size = '2em' }: BrandIconProps) {
  if (!brand) return null;
  const Icon = brandMap[brand.toUpperCase()];
  if (!Icon) return null;
  return <Icon size={size} />;
}

export default BrandIcon;
